<div class="flex flex-col min-h-screen">
  <app-header></app-header>
  <main class="flex-1 p-5">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
